// extracted by mini-css-extract-plugin
export default {"Serif":"Settings_Serif__fl2l4","SansSerif":"Settings_SansSerif__UgQet","Mono":"Settings_Mono__716Ku"};